module.exports = __webpack_public_path__ + "static/media/venus.3e01aab4.svg";